module.exports = __webpack_public_path__ + "static/media/gtw.83c934d3.svg";